/**
 * Created by tomnotcat on 2023/11/08.
 */
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { Text, View, TouchableOpacity, TextInput, Clipboard } from "react-native";
import { Text as NBText } from "native-base";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import ClipLoader from "react-spinners/ClipLoader";
import Icon from "react-native-vector-icons/Ionicons";
import * as Helper from "../../utils/Helper";
import ReviewService from "../../../services/screens/admin/homework/management/ReviewService"
import MessageBox from "./MessageBox";
import UIDs from "../../UIDs";

const uid = UIDs.components.ui.wordAnalysisView;

const WordAnalysisView = (props) => {
    const { t } = props;

    const [wordAnalysisModal, setWordAnalysisModal] = useState(false);
    const [wordAnalysisData, setWordAnalysisData] = useState(null);

    const showWordAnalysis = () => {
        if (!wordAnalysisData) {
            ReviewService.getLexicalAnalysis({
                text: props.text,
            }, response => {
                setWordAnalysisData(response);
            }, error => {
                MessageBox.danger({
                    text: error.message || error.toString(),
                    duration: 5000,
                });
            });
        }
        setWordAnalysisModal(true);
    };

    const renderWordAnalysisTrans = (data) => {
        if (!data) {
            return (<div style={{height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <ClipLoader css="width:32px;height:32px;"/>
                    </div>);
        }

        const { correction, totalWords, uniqueWords, attributes, levels, wordFrequency } = data;
        const richness = totalWords > 0 ? (uniqueWords / totalWords) : 0;
        const levelDatas = [
            { unique: 0, total: 0 },
            { unique: 0, total: 0 },
            { unique: 0, total: 0 },
            { unique: 0, total: 0 },
            { unique: 0, total: 0 },
            { unique: 0, total: 0 },
            { unique: 0, total: 0 },
        ];

        for (let k in levels) {
            let index = parseInt(k) - 1;
            if (index >= levelDatas.length) {
                index = levelDatas.length - 1;
            }

            let words = levels[k];
            levelDatas[index].unique = words.length;
            for (let i = 0; i < words.length; ++i) {
                levelDatas[index].total += wordFrequency[words[i]];
            }
        }

        return (
            <table className="table table-bordered  text-center pssd1aiview">
                <thead>
                    <tr>
                        <th scope="col">{t("level")}</th>
                        {levelDatas.map((it, i) => (
                            <th scope="col" key={i} style={styles.row}>
                                {t("wordLevel_" + (i + 1))}
                            </th>
                        ))}
                        <th scope="col">{t("lexicalRichness")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">{t("wordType")}</th>
                        {levelDatas.map((it, i) => (
                            <td key={i} style={styles.row}>
                                {it.unique}
                            </td>
                        ))}
                        <td rowSpan={3} valign="middle" style={{ verticalAlign: "middle" }}>
                            {Helper.trimTailZero((richness * 100).toFixed(2))}%
                            <p>({t("richnessDesc")})</p>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{t("wordToken")}</th>
                        {levelDatas.map((it, i) => (
                            <td key={i} style={styles.row}>
                                {it.total}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <th scope="row">{t("tokenPencent")}</th>
                        {levelDatas.map((it, i) => (
                            <td key={i} style={styles.row}>
                                {totalWords > 0 ? Helper.trimTailZero(((it.total / totalWords) * 100).toFixed(2)) : 0}%
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            {props.style ?
             (<TouchableOpacity
                style={props.style}
                onPress={() => showWordAnalysis()}>
                <NBText style={{ color: "#fff" }}>{t("lexicalAnalysis")}</NBText>
              </TouchableOpacity>) :
             (<TouchableOpacity
                style={[styles.btnSubmitAutoWidth, { borderRadius: 8, marginRight: 6 }]}
                transparent
                onPress={() => showWordAnalysis()}>
                <Text style={{ color: "#fff" }}>{t("lexicalAnalysis")}</Text>
              </TouchableOpacity>)}
            {/*
            <Button color="primary" onClick={() => showWordAnalysis()}>
                {t("showWordAnalysis")}
            </Button>
             */}
            <Modal size={"lg"} isOpen={wordAnalysisModal}>
                <ModalHeader className="aic-modal-header" style={{ padding: "10px 10px 5px", height: "40px" }} toggle={() => setWordAnalysisModal(false)} charCode="X">
                    <h3>{t("lexicalAnalysis")}</h3>
                </ModalHeader>
                <ModalBody>
                    <div style={{width:"100%", overflowX:"auto"}}>{renderWordAnalysisTrans(wordAnalysisData)}</div>
                </ModalBody>
            </Modal>
        </>
    );
};

const styles = {
    close: {
        zIndex: 10,
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: -6,
        right: -6,
        width: 12,
        height: 12,
        borderRadius: 6,
        backgroundColor: "rgba(255,0,0,0.5)",
    },
    closeText: {
        userSelect: "none",
        cursor: "pointer",
        fontSize: 9,
        color: "#fff",
    },
    edit: {
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 4,
        borderColor: "#ccc",
        padding: 10,
    },
    button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        paddingLeft: 20,
        paddingRight: 20,
        backgroundColor: "#6075e1",
        borderColor: "#6075e1",
        color: "#fff",
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 4,
    },
    row0: {
        flexDirection: "row",
        borderTopWidth: 1,
        borderTopColor: "transparent",
        height: 40,
    },
    row: {
        flexDirection: "row",
        borderTopWidth: 1,
        borderTopColor: "#ccc",
        height: 40,
    },
    col0: {
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
    },
    col: {
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        borderLeftWidth: 1,
        borderLeftColor: "#ccc",
    },
    col3: {
        alignItems: "center",
        justifyContent: "center",
        flex: 3,
        borderLeftWidth: 1,
        borderLeftColor: "#ccc",
    },
    btnSubmitAutoWidth: {
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#1E90FF",
        height: 40,
        borderRadius: 30,
        paddingLeft:10,
        paddingRight:10,
    },
};

export default withTranslation(uid, { withRef: true })(WordAnalysisView);
